import { DashboardConfig } from '../../../../common/components/dashboards/types';
import { Languages } from '../../../../constants';
import { getNikkiGlobalHRDbPageConfigs } from './nikki-global-hr-as-db-page-configs';

const dashboardId = 'global_hr_as_headcount';
export const NikkiGlobalHrAsDashboardConfig: DashboardConfig = {
  id: dashboardId,
  title: {
    [Languages.EN]: 'Global HR AS Headcount',
    [Languages.JA]: 'Global HR AS Headcount',
  },
  enabled: true,
  pages: getNikkiGlobalHRDbPageConfigs(dashboardId),
};
